module.exports = __webpack_public_path__ + "static/media/photo-9.86c9dd99.jpg";